import React from 'react';
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import {
    testimonialImage1,
    testimonialImage2,
    testimonialImage3
} from '../../assets/icons';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import './testimonials.css';

const comments = [

    {
        id: "1",
        image: testimonialImage1,
        name: "Harshit Verma",
        // class: "Class 12",
        comment: "Covered all practice problems in less than two days.",
    },
    {
        id: "2",
        image: testimonialImage2,
        name: "Yash Sharma",
        // class: "Class 11",
        comment: "I was able to complete all 18 questions within 1 hr time limit."
    },
    {
        id: "3",
        image: testimonialImage3,
        name: "Vats Agarwal",
        // class: "Class 10",
        comment: "Tough problems seem way easier now.",
    },
];


export function TestimonialCards({ data }) {

    return (
        <div className="testimonial__card">
            <div className="testimonial__card__comment">
                <span className='app-italic'>" </span>
                {data.comment}
                <span className='app-italic'>" </span>  </div>
            <img className="testimonial__card__pic"
                src={data.image}
                alt={data.name}
            />
            <div className="testimonial__card__name">{data.name}</div>
        </div>
    )
}

function Testimonials() {

    const breakpoints = {
        600: {
            slidesPerView: 1,
        },

        800: {
            slidesPerView: 2,
        },

        1024: {
            slidesPerView: 3,
        },
    };

    return (

        <div className='testimonials'>
            <h2 className="tesitmonials__title">Testimonials</h2>
            <div className="tesitmonials__swiper">
                <Swiper              // install Swiper modules
                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                    spaceBetween={20}
                    pagination={{ clickable: true }}
                    breakpoints={breakpoints}
                    loop={1}
                >
                    {comments.map((data) => <SwiperSlide key={data.id} >
                        <TestimonialCards data={data} />
                    </SwiperSlide>
                    )}
                </Swiper>
            </div>
        </div>

    )
}

export default Testimonials